import script from "./Billing.vue?vue&type=script&setup=true&lang=js"
export * from "./Billing.vue?vue&type=script&setup=true&lang=js"

import "./Billing.vue?vue&type=style&index=0&id=9836ee96&lang=less&scoped=true"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-9836ee96"]])

export default __exports__